export default __webpack_public_path__ + "fd7019d.png";